var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticStyle:{"margin-top":"20%","text-align":"center"}},[_vm._v("银联分期支付成功，课程已开通！")])])}]

export { render, staticRenderFns }